import { formatTime } from "shared/utils/formatTime"

import styles from "./Timestamp.module.css"

export type TimestampProps = {
  currentTime: number
}

export const Timestamp = ({ currentTime }: TimestampProps) => {
  return (
    <span
      className={`body-md text-color-primary-inverse ${styles.timestamp}`}
    >
      {formatTime(currentTime)}
    </span>
  )
}
